var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { "has-crossprice": _vm.hasCrossPrice } }, [
    _vm.showCrossPrice && _vm.hasCrossPrice
      ? _c(
          "div",
          {
            staticClass: "crossprice singleCross",
            class: { "is-special-offer": _vm.hasSpecialOffer }
          },
          [
            _c(
              "div",
              [
                _vm.hasSpecialOffer
                  ? [
                      _vm.startingPrice ? [_vm._v("ab ")] : _vm._e(),
                      _vm._v(
                        _vm._s(
                          _vm._f("itemCrossPrice")(
                            _vm.currentVariation.prices.default.unitPrice
                              .formatted,
                            true
                          )
                        ) + "\n            "
                      )
                    ]
                  : [
                      _vm.startingPrice ? [_vm._v("ab ")] : _vm._e(),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("itemCrossPrice")(
                              _vm.currentVariation.prices.rrp.unitPrice
                                .formatted
                            )
                          ) +
                          "\n            "
                      )
                    ]
              ],
              2
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "span",
      {
        staticClass: "price h1",
        class: { "is-special-offer": _vm.hasSpecialOffer }
      },
      [
        _c(
          "span",
          [
            _vm.showDynamicPrice
              ? [
                  _vm.startingPrice ? [_vm._v("ab ")] : _vm._e(),
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$translate(
                          "Ceres::Template.dynamicVariationPrice",
                          {
                            price: _vm.$options.filters.currency(
                              _vm.variationTotalPrice,
                              _vm.currentVariation.prices.default.currency
                            )
                          }
                        )
                      ) +
                      "\n            "
                  )
                ]
              : [
                  _vm.startingPrice ? [_vm._v("ab ")] : _vm._e(),
                  _vm._v(
                    _vm._s(
                      _vm._f("currency")(
                        _vm.variationTotalPrice,
                        _vm.currentVariation.prices.default.currency
                      )
                    ) + "\n            "
                  )
                ]
          ],
          2
        ),
        _vm._v(" "),
        _c("sup", [_vm._v("*")])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }